// extracted by mini-css-extract-plugin
module.exports = {"formDiv":"addToCollection_formDiv__kYfRB","Textarea":"addToCollection_Textarea__1rqfD","Input":"addToCollection_Input__3xott"};